// importing local assets:
import lineFollowingRobotGif from "../../../assets/devlog-gifs/line_following_robot.webp";
import spendWiseGif from "../../../assets/devlog-gifs/spendwise_showcase.webp";
import enchantedLabyrinthGif from "../../../assets/devlog-gifs/enchanted_labyrinth.webp";
import rayMarchingTechniqueGif from "../../../assets/devlog-gifs/ray_marching_technique.webp";
import genuary2023Gif from "../../../assets/devlog-gifs/Genuary_2023.webp";

export const devlogData = [
  {
    title: "Line Following Robot Evolution Using NEAT",
    imgLink: lineFollowingRobotGif,
    visitLink: "https://youtu.be/rkD4sEfp05M",
  },
  {
    title: "Project Showcasing - SpendWise",
    imgLink: spendWiseGif,
    visitLink: "https://youtu.be/YP4A0PK7GUM",
  },
  {
    title: "Enchanted Labyrinth (web game)",
    imgLink: enchantedLabyrinthGif,
    visitLink: "https://youtu.be/z2tS1Fr0sOA",
  },
  {
    title: "Ray Marching Technique",
    imgLink: rayMarchingTechniqueGif,
    visitLink: "https://youtu.be/kAbRlHOlm6Y",
  },
  {
    title: "Genuary 2023 (Challenge 01)",
    imgLink: genuary2023Gif,
    visitLink: "https://youtu.be/LCDUWvePc-U",
  },
];
